export default function IsraelFlag({ className = "w-8 h-6" }: { className?: string }) {
  return (
    <div className={`${className} relative overflow-hidden rounded-sm shadow-sm border border-border`}>
      {/* White background */}
      <div className="w-full h-full bg-white flex flex-col justify-between py-[2px]">
        {/* Top blue stripe */}
        <div className="w-full h-[20%] bg-[#0038b8]"></div>
        {/* Bottom blue stripe */}
        <div className="w-full h-[20%] bg-[#0038b8]"></div>
      </div>
      
      {/* Star of David (Magen David) */}
      <svg 
        className="absolute inset-0 m-auto" 
        style={{ width: '35%', height: '35%' }}
        viewBox="0 0 100 100"
        fill="none"
      >
        {/* Upward triangle */}
        <polygon points="50,15 85,65 15,65" fill="#0038b8" />
        {/* Downward triangle */}
        <polygon points="50,85 15,35 85,35" fill="#0038b8" />
      </svg>
    </div>
  );
}
